import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AddUserModal from "./AddUserModal";
import ManageAnnouncementsModal from "./ManageAnnouncementsModal";
import './NavBar.css';

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const handleAddUserClick = () => {
    setShowAddUserModal(true);
    setMenuOpen(false);
  };

  const handleAnnouncementsClick = () => {
    setShowAnnouncementsModal(true);
    setMenuOpen(false);
  };

  return (
    <>
      <header className="nav-header">
        <nav className="nav">
          <div className="nav-inner">
            <h1 className="nav-logo">MPSc</h1>
            <button
              className={`nav-toggle${menuOpen ? ' open' : ''}`}
              aria-label="Toggle navigation menu"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
            <ul className={`nav-links${menuOpen ? ' open' : ''}`}>
              <li><Link to="/" onClick={() => setMenuOpen(false)}>HOME</Link></li>
              <li><Link to="/admissions" onClick={() => setMenuOpen(false)}>ADMISSIONS</Link></li>
              <li><Link to="/program-of-study" onClick={() => setMenuOpen(false)}>PROGRAM</Link></li>
              <li><Link to="/our-people" onClick={() => setMenuOpen(false)}>OUR PEOPLE</Link></li>
              <li><Link to="/announcements" onClick={() => setMenuOpen(false)}>ANNOUNCEMENTS</Link></li>
              <li><Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link></li>
              {isAuthenticated && (
                <>
                  <li>
                    <button 
                      className="nav-button" 
                      onClick={handleAnnouncementsClick}
                    >
                      MANAGE ANNOUNCEMENTS
                    </button>
                  </li>
                  <li>
                    <button 
                      className="nav-button" 
                      onClick={handleAddUserClick}
                    >
                      ADD USER
                    </button>
                  </li>
                  <li>
                    <button 
                      className="nav-button" 
                      onClick={handleLogout}
                    >
                      LOGOUT
                    </button>
                  </li>
                </>
              )}
              {!isAuthenticated && (
                <li><Link to="/login" onClick={() => setMenuOpen(false)}>ADMIN LOGIN</Link></li>
              )}
              <button className="nav-close" aria-label="Close menu" onClick={() => setMenuOpen(false)}>&times;</button>
            </ul>
          </div>
        </nav>
      </header>
      <AddUserModal 
        isOpen={showAddUserModal} 
        onClose={() => setShowAddUserModal(false)} 
      />
      <ManageAnnouncementsModal 
        isOpen={showAnnouncementsModal} 
        onClose={() => setShowAnnouncementsModal(false)} 
      />
    </>
  );
};

export default NavBar; 